<template>
  <div>
    <HeaderEditorial />
    <main>
      <ErrorBoundary>
        <slot />
      </ErrorBoundary>
    </main>
    <FooterLuxury />
    <JoinListFloatingCta />
  </div>
</template>
